export default "__VITE_ASSET__BWjWvX03__"